import { FC, useMemo } from "react";
import styles from "./ProgressLowHighLimit.module.less";
import { Typography } from "antd";

interface ProgressLowHighLimitProps {
  end: number;
  current: number;
  start: number;
  warning: number;
  mean?: number;
  showLabel?: boolean;
  showDivider?: boolean;
  containerStyle?: React.CSSProperties;
}

const ProgressLowHighLimit: FC<ProgressLowHighLimitProps> = ({
  end,
  current,
  warning,
  // mean,
  showLabel,
  showDivider,
  containerStyle,
}) => {
  const percentileValues = useMemo(() => {
    return {
      current: Math.floor((current / end) * 100),
      warning: Math.floor((warning / end) * 100),
    };
  }, [current, warning, end]);

  return (
    <div className={styles.progressLowHighLimit} style={containerStyle}>
      {showDivider && <div className={styles.divider} />}

      <div className={styles.progressContainer}>
        <div
          className={styles.normalZone}
          style={{ width: `${percentileValues.warning}%` }}
        />
        <div
          className={styles.warningZone}
          style={{ width: `${100 - percentileValues.warning}%` }}
        />

        <div
          className={styles.current}
          style={{ left: `${percentileValues.current}%` }}
        >
          <img src="/icons/current_icon.svg" width={5} alt="current" />
          {showLabel && (
            <Typography.Text className={styles.label}>Current</Typography.Text>
          )}
        </div>
      </div>

      {showDivider && <div className={styles.divider} />}
    </div>
  );
};

export default ProgressLowHighLimit;
